angular
  .module("AccountingBoxApp")
  .controller("ReportingBalanceSheetCtrl", function(
    $scope,
    $http,
    $state,
    FileUploader,
    LoopBackAuth,
    Journal,
    Rapporting,
    Sale,
    Purchase,
    BankTransaction,
    BankAccount,
    $location,
    $rootScope
  ) {
    $scope.order = {
      by: "date",
      reverse: false,
      filter: ""
    };

    $scope.options = {
      language: "nl",
      todayHighlight: true,
      format: "dd-mm-yyyy",
      autoclose: true
    };

    var vm = this;

    vm.dates = {
      startDate: moment(),
      endDate: moment()
    };
    vm.balanceSheet = {};

    vm.year = "open";

    vm.level = "4";

    vm.displayYears = $rootScope.displayYears.filter(function(option) {
      return option.value !== "all";
    });

    vm.yearChanged = function() {
      var year = vm.year;
      if (year === "open") {
        vm.dates = {
          startDate: moment()
            .year($rootScope.currentYear())
            .startOf("year"),
          endDate: moment().endOf("year")
        };
      } else {
        vm.dates = {
          startDate: moment()
            .year(year)
            .startOf("year"),
          endDate: moment()
            .year(year)
            .endOf("year")
        };
      }

      $location.search("startDate", vm.dates.startDate.format("L"));
      $location.search("endDate", vm.dates.endDate.format("L"));
    };

    // vm.yearChanged();

    //set query based on url
    $scope.$watch(
      function() {
        return $location.search();
      },
      function(url) {
        if (url) {
          updateDates();
        }
      }
    );

    if (!$location.search().startDate && !$location.search().endDate) {
      vm.yearChanged();
    }

    //Watch for date changes
    $scope.$watch(
      "rbs.dates",
      function(newDate) {
        vm.dateChanged();
      },
      false
    );

    vm.dateChanged = function() {
      // var startDate = vm.dates.startDate.toDate();
      // var endDate = vm.dates.endDate.toDate();
      if (!vm.dates.startDate || !vm.dates.endDate) return;

      $location.search("startDate", vm.dates.startDate.format("L"));
      $location.search("endDate", vm.dates.endDate.format("L"));
      vm.loading = true;
      Rapporting.balanceSheet(
        {
          beginDate: vm.dates.startDate.toDate(),
          endDate: vm.dates.endDate.toDate()
        },
        function(result) {
          vm.balanceSheet = result.balance;
          vm.loading = false;
          // console.log("balanceSheet is: ", vm.balanceSheet);
        }
      );
    };

    // $scope.$watch("rbs.dates", function(newValue, oldValue) {
    //   vm.dateChanged();
    // });

    function updateDates() {
      if ($location.search().startDate && $location.search().endDate) {
        vm.dates = {
          startDate: moment($location.search().startDate, "L"),
          endDate: moment($location.search().endDate, "L")
        };

        // || moment().startOf('year').format('DD-MM-YYYY');
        // vm.dates.endDate = moment($location.search().endDate, "L"); // || moment().endOf('year').format('DD-MM-YYYY');
      }
    }

    vm.categories = function() {
      if (!vm.balanceSheet.categories) return [];
      return Object.values(vm.balanceSheet.categories);
    };
    vm.subCategories = function(category) {
      return Object.values(category.subCategories);
    };
    vm.accounts = function(subCategory) {
      return Object.values(subCategory.accounts);
    };
    vm.subAccounts = function(account) {
      if (!account.subAccounts) return [];
      return Object.values(account.subAccounts);
    };

    vm.toTransaction = function(journalLine) {
      Journal.findById({ id: journalLine.journalId }, function(journal) {
        if (!journal) {
          return alert("Journaal niet gevonden");
        }
        console.log('journal',journal)
        var url;
        if (journal.transactionType === "BankTransaction") {
          url = $state.href("app.company.bank.transactions", {id: journal.transaction.bankAccountId});
          url =`${url}?bankTransactionId=${journal.transaction.id}`;
        } else {
          var to = journal.transactionType.toLowerCase() + "s";
          if (journal.transactionType.toLowerCase() === "journalentry") {
            to = "journalEntries";
          }
          url = $state.href("app.company.edit." + to, {
            id: journal.transactionId
          });
        }

        window.open(url, "_blank");
      });
    };
    vm.today = function() {
      return moment().format("L");
    };
  });
